import { INIT_GAME_SETTINGS_STATE, GameSettingsState } from './gameSettings.state';
import * as GameSettingsAction from './gameSettings.actions';
import { Action, createReducer, on } from '@ngrx/store';

const _gameSettingsReducer = createReducer(

    INIT_GAME_SETTINGS_STATE,

    on(
        GameSettingsAction.toggleStatsAction,
        (state, action) => ({
            ...state,
            showStatsUI: cycleStatsUI(state.showStatsUI),
        })
    ),

)

function cycleStatsUI(currentStatsUI: string | null): string | null {
    switch (currentStatsUI) {
        case 'VPIP': {
            return 'PFR';
        }
        case 'PFR': {
            return 'AF';
        }
        case 'AF': {
            return 'W2S';
        }
        case 'W2S': {
            return 'W$@S';
        }
        default:
            if (currentStatsUI == null) {
                return 'VPIP';
            } else {
                return null;
            }
    }
}

export function gameSettingsReducer(state: GameSettingsState, action: Action) {
    return _gameSettingsReducer(state, action);
}
